"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var __1 = require("..");
var Item = function (_a) {
    var arrow = _a.arrow, bottomBorder = _a.bottomBorder, content = _a.content, onClick = _a.onClick, open = _a.open, slug = _a.slug, theme = _a.theme, title = _a.title;
    var renderTitle = function (arrowType) {
        switch (arrowType) {
            case 'default':
                return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "accordion-item-title-".concat(theme, " ").concat(open ? 'open' : ''), onClick: onClick }, { children: title })));
            case 'bracket':
            case 'bracket-horizontal':
                return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)("accordion-item-title-".concat(theme), open ? 'open' : undefined), onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "accordion-item-title-".concat(theme, "-label") }, { children: title })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "accordion-item-title-".concat(theme, "-arrow ").concat(open ? 'open' : '') }, { children: (0, jsx_runtime_1.jsx)(__1.Icon, { icon: arrow === 'bracket-horizontal' ? 'icon_arrow_right_dark' : 'icon_arrow_down_dark', size: theme === 'orange-inverted' || theme === 'orange-bordered' ? 'lg' : 'xxl' }) }))] })));
        }
    };
    var renderContent = function () {
        return (0, function_1.pipe)(O.fromNullable(open), O.filter(function (o) { return o === true; }), O.chainNullableK(function (_) { return content; }), O.map(function (c) { return (typeof c === 'function' ? c() : c); }), O.toNullable);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "accordion-item-".concat(theme) }, { children: [renderTitle(arrow), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)("accordion-item-content-".concat(theme), { open: open }, { 'border-bottom': bottomBorder === true }) }, { children: (0, jsx_runtime_1.jsx)("div", { children: renderContent() }) }))] }), slug));
};
exports.Item = Item;
//# sourceMappingURL=Item.js.map